// ── "Is this row dust?" — the SERVER decides (audit T14, 2026-10-11) ─────────
//
// Every ledger / picker endpoint (order pickers, Assign Transactions,
// Transaction History, the Crypto Balance ledgers) projects `is_dust` on each
// row: 1 = the on-chain dust / spam classification (stablecoin received under
// 1 unit since 2026-10-17 — was 10 —, sub-cent noise, or marked dust by
// finance; cleared by Undust).
// Screens hide those rows by default and offer them only "Undust".
//
// NEVER re-derive dust from the amount here. There used to be four client
// rules (stablecoin < 5 in either direction in the order pickers, < 0.01 of
// anything elsewhere) and none of them matched the server's — a 3 USDT
// outgoing row the server offered was invisible in Create Order, while a
// 0.005 BTC row (real money) was hidden in Transaction History.
export const isDust = (row) => !!row && (row.is_dust === true || Number(row.is_dust) === 1);

// Picker rows minus dust — ONE definition shared by Create Order and the
// Order History edit picker (modal-open fetch and stale-tab refresh alike).
export const withoutDust = (rows) => (rows || []).filter((row) => !isDust(row));
